<template>
    <div class="BookingContactForm">
        <v-form>
         <v-row>
             <v-col cols="2">
                 <h5>Course</h5>
             </v-col>

             <v-col cols="5">
                 <v-text-field
                         v-model="model.delegates"
                         label="Delegates"
                         type="number"
                         @change="calculatePrice"
                         :readonly="readonly"
                 ></v-text-field>
             </v-col>
             <v-col cols="5">
                 <v-text-field
                         v-model="model.courseRate"
                         label="Course Rate"
                         type="number"
                         step=".01"
                         prefix="£"
                         @change="calculatePrice"
                         :readonly="readonly"
                 ></v-text-field>
             </v-col>
         </v-row>
            <v-row>
                <v-col cols="2">
                    <h5>Per Day</h5>
                </v-col>
             <v-col>
                 <v-text-field
                         v-model="model.days"
                         label="Days *"
                         type="number"
                         @change="calculatePrice"
                         :readonly="readonly"
                 ></v-text-field>
             </v-col>
             <v-col>
                 <v-text-field
                         v-model="model.dayRate"
                         label="Day Rate *"
                         type="number"
                         prefix="£"
                         step=".01"
                         @change="calculatePrice"
                         :readonly="readonly"
                 ></v-text-field>
             </v-col>
         </v-row>
            <v-row>
                <v-col cols="2">
                    <h5>Totals</h5>
                </v-col>
             <v-col cols="5">
                 <v-text-field
                         v-model="originalPrice"
                         label="Original Price"
                         type="number"
                         prefix="£"
                         v-if="this.updatedPrice"
                         color="red"
                         readonly
                         outlined
                 ></v-text-field>
             </v-col>
             <v-col cols="5">
                 <v-text-field
                         v-model="model.totalPrice"
                         label="Price"
                         type="number"
                         prefix="£"
                         readonly
                         outlined
                 ></v-text-field>
             </v-col>
         </v-row>
            <v-row>
                <v-col cols="2">
                    <h5>VAT</h5>
                </v-col>

                <v-col cols="5">
                    <v-text-field
                            v-model="model.vatRate"
                            label="VAT Rate"
                            type="number"
                            suffix="%"
                            readonly

                    >
                    </v-text-field>
                </v-col>
                <v-col cols="5">
                    <v-text-field
                            v-model="model.vatAmount"
                            label="VAT"
                            type="number"
                            prefix="£"
                            readonly
                    >

                    </v-text-field>
                    <v-text-field
                            v-model="model.grossPrice"
                            label="Gross"
                            type="number"
                            prefix="£"
                            readonly
                            dense
                    ></v-text-field>
                </v-col>
            </v-row>
        </v-form>
    </div>
</template>

<script>




    export default {
        components: {
        },
        props: {
            model: Object,
            readonly: {
                type: Boolean,
                default:false
            },
        },
        data() {
            return {
                updatedPrice: false,
                originalPrice: null
            }
        },
        methods: {
          calculatePrice() {
              if(!this.updatedPrice){
                  this.updatedPrice = true
                  this.originalPrice = this.model.totalPrice
              }

              let price = (this.model.delegates * this.model.courseRate) + (this.model.days * this.model.dayRate)
              let vat = price * this.model.vatRate
              let gross = price + vat
              this.model.vatAmount = vat
              this.model.totalPrice = price
              this.model.grossPrice = gross
          }
        },
    }
</script>
